/**
 * @flow
 * @relayHash 5f4bc35ee260e5905c899cbc35097065
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BrandsCards_brandsInfo$ref = any;
type Product_productInfo$ref = any;
export type TaxonKind = "category" | "department" | "sub_category" | "sub_department" | "%future added value";
export type SubDepartmentsInfoQueryVariables = {|
  type?: ?TaxonKind,
  vendor_id?: ?string,
  id?: ?string,
|};
export type SubDepartmentsInfoQueryResponse = {|
  +taxons: $ReadOnlyArray<?{|
    +id: string,
    +ref_id: string,
    +name: string,
    +logo: ?string,
    +caption: ?string,
    +type: string,
    +children: ?$ReadOnlyArray<?{|
      +name: string,
      +id: string,
      +ref_id: string,
      +type: string,
      +caption: ?string,
      +products: ?$ReadOnlyArray<?{|
        +$fragmentRefs: Product_productInfo$ref
      |}>,
      +children: ?$ReadOnlyArray<?{|
        +name: string,
        +id: string,
        +ref_id: string,
        +type: string,
        +caption: ?string,
        +products: ?$ReadOnlyArray<?{|
          +$fragmentRefs: Product_productInfo$ref
        |}>,
      |}>,
    |}>,
    +top_brands: ?$ReadOnlyArray<?{|
      +$fragmentRefs: BrandsCards_brandsInfo$ref
    |}>,
  |}>
|};
export type SubDepartmentsInfoQuery = {|
  variables: SubDepartmentsInfoQueryVariables,
  response: SubDepartmentsInfoQueryResponse,
|};
*/


/*
query SubDepartmentsInfoQuery(
  $type: TaxonKind
  $vendor_id: ID
  $id: ID
) {
  taxons(type: $type, vendor_id: $vendor_id, id: $id) {
    id
    ref_id
    name
    logo
    caption
    type
    children(vendor_id: $vendor_id) {
      name
      id
      ref_id
      type
      caption
      products(vendor_id: $vendor_id, limit: 8) {
        ...Product_productInfo_10BuI4
        id
      }
      children(vendor_id: $vendor_id) {
        name
        id
        ref_id
        type
        caption
        products(vendor_id: $vendor_id, limit: 8) {
          ...Product_productInfo_10BuI4
          id
        }
      }
    }
    top_brands(vendor_id: $vendor_id) {
      ...BrandsCards_brandsInfo
      id
    }
  }
}

fragment Product_productInfo_10BuI4 on Product {
  id
  slug
  vendor_variants_count
  min_variant(vendor_id: $vendor_id) {
    vendor {
      name
      ref_id
      id
    }
    slug
    name
    ref_id
    root_variant_id
    discount_expire_at
    remaining_usage_percentage
    total_on_hand
    price
    original_price
    id
  }
  ref_id
  images
  name
  avg_rating
  rating_count
  price
  original_price
  discount
  has_discount
  has_offer
  hot_deal
  wish_listed
  root_variant {
    root_variant_id
    ref_id
    wish_listed
    id
  }
  variants {
    id
    ref_id
    option_values {
      id
      ref_id
      option_type_name
    }
  }
  related_products {
    images
    name
    id
  }
  gift_image {
    url_large
    url_original
  }
  gift_text
  gift_included
}

fragment BrandsCards_brandsInfo on Taxon {
  id
  ...TrackCard_cardInfo
}

fragment TrackCard_cardInfo on Taxon {
  id
  name
  logo
  icon
  ref_id
  type
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "TaxonKind",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "vendor_id",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "vendor_id",
  "variableName": "vendor_id",
  "type": "ID"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type",
    "type": "TaxonKind"
  },
  v1
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v9 = [
  v1
],
v10 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 8,
    "type": "Int"
  },
  v1
],
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "products",
  "storageKey": null,
  "args": v10,
  "concreteType": "Product",
  "plural": true,
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Product_productInfo",
      "args": [
        {
          "kind": "Variable",
          "name": "vendor_id",
          "variableName": "vendor_id",
          "type": null
        }
      ]
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "root_variant_id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "original_price",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "images",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "wish_listed",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "products",
  "storageKey": null,
  "args": v10,
  "concreteType": "Product",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "discount",
      "args": null,
      "storageKey": null
    },
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vendor_variants_count",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "min_variant",
      "storageKey": null,
      "args": v9,
      "concreteType": "Variant",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "discount_expire_at",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "vendor",
          "storageKey": null,
          "args": null,
          "concreteType": "Shop",
          "plural": false,
          "selections": [
            v5,
            v4,
            v3
          ]
        },
        v5,
        v4,
        v12,
        v13,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "remaining_usage_percentage",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "total_on_hand",
          "args": null,
          "storageKey": null
        },
        v14,
        v15,
        v3
      ]
    },
    v4,
    v16,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "avg_rating",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rating_count",
      "args": null,
      "storageKey": null
    },
    v14,
    v15,
    v13,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "has_discount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "has_offer",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hot_deal",
      "args": null,
      "storageKey": null
    },
    v17,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "root_variant",
      "storageKey": null,
      "args": null,
      "concreteType": "Variant",
      "plural": false,
      "selections": [
        v12,
        v4,
        v17,
        v3
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "variants",
      "storageKey": null,
      "args": null,
      "concreteType": "Variant",
      "plural": true,
      "selections": [
        v3,
        v4,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "option_values",
          "storageKey": null,
          "args": null,
          "concreteType": "OptionValue",
          "plural": true,
          "selections": [
            v3,
            v4,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "option_type_name",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "related_products",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        v16,
        v5,
        v3
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "gift_image",
      "storageKey": null,
      "args": null,
      "concreteType": "ImageAttachment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url_large",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url_original",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "gift_text",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "gift_included",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SubDepartmentsInfoQuery",
  "id": null,
  "text": "query SubDepartmentsInfoQuery(\n  $type: TaxonKind\n  $vendor_id: ID\n  $id: ID\n) {\n  taxons(type: $type, vendor_id: $vendor_id, id: $id) {\n    id\n    ref_id\n    name\n    logo\n    caption\n    type\n    children(vendor_id: $vendor_id) {\n      name\n      id\n      ref_id\n      type\n      caption\n      products(vendor_id: $vendor_id, limit: 8) {\n        ...Product_productInfo_10BuI4\n        id\n      }\n      children(vendor_id: $vendor_id) {\n        name\n        id\n        ref_id\n        type\n        caption\n        products(vendor_id: $vendor_id, limit: 8) {\n          ...Product_productInfo_10BuI4\n          id\n        }\n      }\n    }\n    top_brands(vendor_id: $vendor_id) {\n      ...BrandsCards_brandsInfo\n      id\n    }\n  }\n}\n\nfragment Product_productInfo_10BuI4 on Product {\n  id\n  slug\n  vendor_variants_count\n  min_variant(vendor_id: $vendor_id) {\n    vendor {\n      name\n      ref_id\n      id\n    }\n    slug\n    name\n    ref_id\n    root_variant_id\n    discount_expire_at\n    remaining_usage_percentage\n    total_on_hand\n    price\n    original_price\n    id\n  }\n  ref_id\n  images\n  name\n  avg_rating\n  rating_count\n  price\n  original_price\n  discount\n  has_discount\n  has_offer\n  hot_deal\n  wish_listed\n  root_variant {\n    root_variant_id\n    ref_id\n    wish_listed\n    id\n  }\n  variants {\n    id\n    ref_id\n    option_values {\n      id\n      ref_id\n      option_type_name\n    }\n  }\n  related_products {\n    images\n    name\n    id\n  }\n  gift_image {\n    url_large\n    url_original\n  }\n  gift_text\n  gift_included\n}\n\nfragment BrandsCards_brandsInfo on Taxon {\n  id\n  ...TrackCard_cardInfo\n}\n\nfragment TrackCard_cardInfo on Taxon {\n  id\n  name\n  logo\n  icon\n  ref_id\n  type\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SubDepartmentsInfoQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "taxons",
        "storageKey": null,
        "args": v2,
        "concreteType": "Taxon",
        "plural": true,
        "selections": [
          v3,
          v4,
          v5,
          v6,
          v7,
          v8,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "children",
            "storageKey": null,
            "args": v9,
            "concreteType": "Taxon",
            "plural": true,
            "selections": [
              v5,
              v3,
              v4,
              v8,
              v7,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "children",
                "storageKey": null,
                "args": v9,
                "concreteType": "Taxon",
                "plural": true,
                "selections": [
                  v5,
                  v3,
                  v4,
                  v8,
                  v7,
                  v11
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "top_brands",
            "storageKey": null,
            "args": v9,
            "concreteType": "Taxon",
            "plural": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "BrandsCards_brandsInfo",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SubDepartmentsInfoQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "taxons",
        "storageKey": null,
        "args": v2,
        "concreteType": "Taxon",
        "plural": true,
        "selections": [
          v3,
          v4,
          v5,
          v6,
          v7,
          v8,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "children",
            "storageKey": null,
            "args": v9,
            "concreteType": "Taxon",
            "plural": true,
            "selections": [
              v5,
              v3,
              v4,
              v8,
              v7,
              v18,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "children",
                "storageKey": null,
                "args": v9,
                "concreteType": "Taxon",
                "plural": true,
                "selections": [
                  v5,
                  v3,
                  v4,
                  v8,
                  v7,
                  v18
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "top_brands",
            "storageKey": null,
            "args": v9,
            "concreteType": "Taxon",
            "plural": true,
            "selections": [
              v3,
              v5,
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "icon",
                "args": null,
                "storageKey": null
              },
              v4,
              v8
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eac3682f83371d53703cf8ba2f2053b7';
module.exports = node;
